import useGateSuggestions from './useGateSuggestions';

const useFullRankPredictor = (fallbackData) => {
  const { key: gateSuggestionSWRKey } = useGateSuggestions({
    fallbackData: fallbackData?.gateSuggestionData
  });

  return {
    keys: {
      gateSuggestionSWRKey
    }
  };
};

export default useFullRankPredictor;
